import create from "zustand";


export default create((set) => {
    return {
        vueMode: 'appartement',
        setVueMode: (mode) => {
            set(() => {
                return { vueMode: mode }
            })
        }
    }
})

